export var DEFAULT_ROUTE_CONTROL_PARAMS = {
  autofocus: true,
  maxWidth: '330px',
  position: {
    right: 72,
    top: 24
  },
  showHeader: true,
  title: 'Построить маршрут'
};
export var DEFAULT_ROUTE_CONTROL_OPTIONS = {
  allowSwitch: false,
  types: {
    pedestrian: true,
    masstransit: true,
    auto: true
  }
};
export var DEFAULT_ROUTE_CONTROL_STATE = {
  type: 'pedestrian'
};
export var CLOSE_BUTTON_POSITION = {
  right: 86,
  top: 38
};
export var MULTI_ROUTE_CONFIG = {
  routeActivePedestrianSegmentStrokeColor: '#0468FF',
  routeActivePedestrianSegmentStrokeStyle: 'shortdot',
  routeActiveStrokeColor: '#0468FF',
  routeActiveStrokeWidth: 4,
  routeActiveTransportSegmentStrokeColor: '#0468FF',
  routeActiveWalkSegmentStrokeColor: '#0468FF',
  routeActiveWalkSegmentStrokeStyle: 'shortdot',
  routeStrokeWidth: 4,
  wayPointFinishIconFillColor: '#0468FF',
  wayPointStartIconFillColor: '#FF1F34'
};
export var BUTTON_LAYOUT = "\n  <ymaps class=\"ymaps_maps-button__close\">\n      <ymaps class=\"ymaps_maps-button-icon_close\" />\n  </ymaps>\n";